import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!

  return (_openBlock(), _createBlock(_component_ontos_header_action, {
    icon: _ctx.modelValue ? 'mdi-eye' : 'mdi-eye-off',
    label: _ctx.$tt('show-closed-items'),
    variant: _ctx.modelValue ? 'tonal' : 'text',
    color: _ctx.modelValue ? 'primary' : undefined,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', !_ctx.modelValue)), ["stop"]))
  }, null, 8, ["icon", "label", "variant", "color"]))
}